import * as d3 from 'd3';
import _ from 'underscore';

import {AlignmentMapState, SummaryMapState} from 'molbio/maps/MapStates';

import * as vo from 'components/VisibilityOptions';
import Component from 'molbio/maps/linear/Component';

class LineView extends Component {
  static initClass() {
    this.prototype.className = 'line';
    this.prototype.setting = vo.LINE.name;
  }

  initialize(options) {
    this.tabstate = options.tabstate; // must be alignment tab state
    this.slice = options.slice;
    this.layout = options.lineLayout;
    this.behind = options.behind;
    if (this.behind) {
      this.layout.setBehind();
    }
    super.initialize(options);
  }

  registerListeners() {
    super.registerListeners();
    if (this.model instanceof SummaryMapState || this.model instanceof AlignmentMapState) {
      this.listenTo(this.model.get('sequence').get('_sequence'), 'renderLineRanges', () => {
        this.update(false);
      });
    }
  }

  getPath(xTransform, yTransform) {
    const lineRanges = this.tabstate.getLineRanges(this.model);
    return {
      correctPath: this._getDataString(lineRanges.correct, xTransform, yTransform),
      mutationPath: this._getDataString(lineRanges.mutation, xTransform, yTransform),
      unknownPath: this._getDataString(lineRanges.unknown, xTransform, yTransform),
    };
  }

  _getDataString(points, xTransform, yTransform) {
    let path = '';
    for (const set of points) {
      path += `M${xTransform(set[0][0])},${yTransform(set[0][1])} `;
      let lastY = -1;
      let refX = -1;
      for (const point of set.slice(1)) {
        const thisX = Math.max(refX + 1, xTransform(point[0]));
        const thisY = yTransform(point[1]);
        if (thisY !== lastY) {
          refX = xTransform(point[0]);
        }
        path += `L${thisX},${thisY} `;
        lastY = thisY;
      }
    }
    return path;
  }

  shouldShow() {
    return this.option.get('visible');
  }

  update(trigger = true) {
    const x = this.slice.x();
    const height = this.behind ? this.tabstate.getType().height() : this.layout.height();
    const y = d3.scaleLinear().domain([0, 1]).range([height, 0]);

    // eslint-disable-next-line no-restricted-syntax
    const paths = _.filter(_.pairs(this.getPath(x, y)), (pair) => pair[1].length > 0);
    const root = d3.select(this.el).select('g').selectAll('path').data(paths);

    const correctColor = this.layout.get('correctFillColor');
    const mutationColor = this.layout.get('mutationFillColor');
    const unknownValueColor = this.layout.get('unknownValueFillColor');
    root
      .join('svg:path')
      .attr('d', (d) => d[1])
      .attr('fill', (d) => {
        if (d[0] === 'correctPath') {
          return correctColor;
        } else if (d[0] === 'unknownPath') {
          return unknownValueColor;
        } else {
          return mutationColor;
        }
      })
      .attr('fill-opacity', this.layout.get('fillOpacity'))
      .attr('data-test-component', 'LineView')
      .attr('data-test-element', 'path');
    if (trigger) {
      this.trigger('redraw');
    }
  }
}
LineView.initClass();

export default LineView;
